import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const ReferralTransition = React.lazy(() =>
    import('../ReferralTransition')
);
const referralTransitionRoutesRegistry = [
    {
        path: PAGE_URL.REFERRAL_TRANSITION_PAGE,
        element: <ReferralTransition />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default referralTransitionRoutesRegistry;
